export interface DeliverySummary {
    id: string
    audienceName: string
    platform: string
    scheduledDate?: string
    completedDate?: string
    status: 'pending' | 'completed'
}

export interface DashboardStats {
    weeklyDeliveries: number
}

export class AudienceService {
    private apiUrl: string
    private fetchFn: (
        input: RequestInfo | URL,
        init?: RequestInit
    ) => Promise<Response>

    constructor(
        apiUrl: string,
        fetchFn: (
            input: RequestInfo | URL,
            init?: RequestInit
        ) => Promise<Response> = fetch
    ) {
        this.apiUrl = apiUrl
        this.fetchFn = fetchFn
    }

    public async getUserClaims(): Promise<Record<string, unknown>> {
        const response = await this.fetchFn(`${this.apiUrl}/protected`)
        return response.json() as Promise<Record<string, unknown>>
    }

    public async mockFetchDeliveries(): Promise<{
        upcoming: DeliverySummary[]
        recent: DeliverySummary[]
    }> {
        // Simulate network delay
        await new Promise((resolve) => setTimeout(resolve, 600))

        const upcoming: DeliverySummary[] = [
            {
                id: '1',
                audienceName: 'Premium Shoppers',
                platform: 'Facebook Ads',
                scheduledDate: 'Today, 3:00 PM',
                status: 'pending',
            },
            {
                id: '2',
                audienceName: 'Enterprise Leads',
                platform: 'Google Ads',
                scheduledDate: 'Tomorrow, 9:00 AM',
                status: 'pending',
            },
        ]

        const recent: DeliverySummary[] = [
            {
                id: '3',
                audienceName: 'Mobile Gaming Users',
                platform: 'Liveramp',
                completedDate: 'Yesterday, 2:30 PM',
                status: 'completed',
            },
            {
                id: '4',
                audienceName: 'Fashion Enthusiasts',
                platform: 'Facebook Ads',
                completedDate: '2 days ago, 11:15 AM',
                status: 'completed',
            },
        ]

        return { upcoming, recent }
    }

    public async mockFetchDashboardStats(): Promise<DashboardStats> {
        // Simulate network delay
        await new Promise((resolve) => setTimeout(resolve, 400))

        return {
            weeklyDeliveries: 2,
        }
    }
}
